export default __webpack_public_path__ + "static/media/Group 3893.1a2aea82.svg";